import Base from "./Base";

export default class GroceryList extends Base {
    all = () => (
        this.get('/groceries')
    )

    find = (id) => (
        this.get(`/groceries/${id}`)
    )
}



// WEBPACK FOOTER //
// ./src/services/api/GroceryList.js